import React, { useCallback, useState, memo, VFC } from 'react';
import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton';
import useIsMounted from 'ismounted';
import styled, { css } from 'styled-components';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

const Root = styled.div`
  position: relative;
  width: 100%;
  padding-top: 100%;
`;

const INNER_STYLES = css`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const Iframe = styled.iframe`
  ${INNER_STYLES};
  border: none;
`;

const SkeletonWrapper = styled.div<{ theme: Theme }>`
  ${INNER_STYLES};
  background-color: ${({ theme }) => theme.palette.common.white};
`;

const StyledSkeleton: VFC<SkeletonProps> = styled(Skeleton)`
  ${INNER_STYLES};
`;

interface MapProps {
  addressText?: string;
}

const Map = memo(({ addressText }: MapProps) => {
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=${process.env.GOOGLE_API_KEY}&zoom=8&q=${addressText}`;

  const [complete, setComplete] = useState(false);

  const isMounted = useIsMounted();

  const handleLoad = useCallback(
    () => isMounted.current && setComplete(true),
    [isMounted, setComplete],
  );

  return (
    <Root>
      <Iframe src={mapUrl} allowFullScreen onLoad={handleLoad} />
      {!complete && (
        <SkeletonWrapper>
          <StyledSkeleton variant="rect" />
        </SkeletonWrapper>
      )}
    </Root>
  );
});

export default Map;
